export default {
  common: {
    name: "Name",
    address: "Address",
    postalCode: "Postcode",
    email: "Email",
    role: "Role",
    breadcrumb: "breadcrumb",
    managingOrganisation: "Managing Organisation",
    dataController: "Data Controller",
    childOrganisations: "Child Organisations",
    teams: "Teams",
    members: "Members",
    currentTeam: "Current Team:",
    unknown: "Unknown",
    yes: "Yes",
    no: "No",
    status: "Status",
    form: "Form",
    forms: "Forms",
    newForm: "New Form",
    newAdmissionForm: "New Admission Form",
    and: "and",
    sendForm: "Send Form",
    sendRequest: "Send request",
    sendInvite: "Send invite",
    sendAssessment: "Send Assessment",
    inviteDoctor: "Invite Doctor to MHA Assessment",
    clickHere: "Click here",
    merge: "Merged",
    refresh: "Refresh",
  },
  buttonLabels: {
    patientLog: "PATIENT LOG",
    activityLog: "ACTIVITY LOG",
    claim: "CLAIM",
    complete: "Complete",
    create: "CREATE",
    close: "CLOSE",
    save: "SAVE",
    goBack: "GO BACK",
    back: "Back",
    sign: "Sign",
    confirm: "CONFIRM",
    filter: "FILTER",
    exit: "EXIT",
    shareForm: "SHARE FORM",
    continue: "CONTINUE",
    start: "START",
    logout: "LOGOUT",
    viewForm: "VIEW FORM",
    continueDraft: "CONTINUE DRAFT",
    startDraft: "START DRAFT",
    view: "VIEW",
    goCompletion: "GO TO COMPLETION",
    assignmentRejection: "REJECT THE ASSIGNMENT",
    clearSearch: "CLEAR SEARCH",
    inputDetails: "INPUT DETAILS MANUALLY",
    search: "SEARCH",
    createPatient: "CREATE PATIENT",
    updatePatient: "UPDATE PATIENT",
    backSearch: "BACK TO SEARCH",
    backPatient: "BACK TO PATIENT",
    home: "HOME PAGE",
    clear: "CLEAR",
    finalise: "FINALISE",
    launch: "Launch",
    createAssignment: "Create Assignment",
    invite: "Invite",
    cancelAssignment: "Cancel Assignment",
    send: "Send",
    archive: "Archive",
    preview: "PREVIEW PDF",
    searchPatient: "SEARCH PATIENT",
    startNew: "START NEW",
    action: "ACTION",
    merge: "MERGE",
    advancedSearch: "ADVANCED SEARCH",
    backToForm: "Back to Form",
    uploadForm: "Upload Form",
    submit: "Submit",
    markComplete: "Mark Complete",
    return: "Return",
    cancel: "Cancel",
    continueToDownload: "Continue to Download",
    tryAgain: "TRY AGAIN",
  },
  errors: {
    somethingWentWrong: "Something went wrong.",
    somethingWentWrongDescription:
      "Please try refreshing the page or contact support if the issue persists.",
    unknownError: "Unknown error",
    userLoadingErrorMessage:
      " Apologies, we're experiencing difficulty in loading your user data at the moment. Please try again later.",
    dashboardLoadingErrorMessage:
      " Apologies, we're experiencing difficulty in loading your dashboard data at the moment. Please try again later.",
  },
  training: {
    onlyShareToTrainingUsers:
      "You can only share to training users/teams while in training mode",
    cannotShareToTrainingUsers: "You cannot share to an training user/team",
    teamPicker: "TRAINING MODE: ",
    dialog:
      "Welcome! You are signed into a training environment of Thalamos' Digital Mental Health Act Solution. Some functionality is restricted. Please do not use this environment for real patient data! Once you have been trained you will be moved into your live environment and added to the appropriate teams.",
    soad: {
      dialog: {
        title: "SOAD Training Environment",
        banner:
          "You are currently accessing a training environment.\nThis environment is provided to help you become familiar with the updated Thalamos CQC platform. Assessments completed here cannot be submitted.\nOnce you have completed the training and the software is live, you will be automatically moved into a live environment. If you believe you should have access to the live system, please contact soadenquiries@cqc.org.uk.",
        confirmation:
          "I understand this is a training environment and real assessments cannot be submitted.",
      },
      banner: {
        body: "You are currently in a training environment. Once you have completed training, and the software is live, you will be moved into a live environment to start completing forms.\nIf you have completed training and expect to see the live environment, please contact soadenquiries@cqc.org.uk",
      },
      postSendDialog: {
        title: "SOAD Training Environment",
        banner:
          "You have completed an assessment on the Thalamos training environment. This assessment has not been submitted to a real provider.\nIf you have completed training and expect to send live SOAD assessments to providers, please contact soadenquiries@cqc.org.uk.",
        confirmation:
          "I understand this is a training environment and this assessment has not been submitted to a real provider.",
      },
    },
  },
  dataController: {
    sharingOutsideDataController: {
      title:
        "You have chosen an email address that is outside of your organisation's data sharing agreements on eMHA. Check you have selected the right email before you click send.",
      yourOrganisation: "Your organisation: {{organisationName}}",
      recipientOrganisation:
        "{{recipientName}}'s organisation: {{organisationName}}",
    },
    sharingToIndependentContext:
      "You are sharing to a user working independently",
    unknown: "Unknown",
    unknownRecipient: "Selected recipient",
  },
};
